(() => {
const selector = 'a.button, button.button, .ea-btn, button.button-label, a.ea-playful__link';
const markup = '<svg viewBox="0 0 64 62" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><g stroke="#3a2217" stroke-width="2.4" stroke-linejoin="round"><path d="M9 36v10c0 13 46 13 46 0V36" fill="#9c6237"/><ellipse cx="32" cy="36" rx="23" ry="8" fill="#d99a43"/><path d="M12 39q6-5 12 0t12 0 13 0" stroke="#f7ce83"/><g class="ea-button-alfajor__lid"><path d="M9 28v9c0 13 46 13 46 0v-9" fill="#67402a"/><ellipse cx="32" cy="28" rx="23" ry="9" fill="#94603e"/><path d="M18 26q13-7 27-2" stroke="#f4d4a5" stroke-linecap="round"/><path d="M27 34h.1m10 0h.1" stroke="#f4d4a5" stroke-width="3" stroke-linecap="round"/></g></g></svg>';
function decorate(root) {
 const items = [];
 if (root.matches && root.matches(selector)) items.push(root);
 if (root.querySelectorAll) items.push(...root.querySelectorAll(selector));
 items.forEach(button => {
  if (button.classList.contains('ea-has-alfajor') || button.matches('.skip-to-content-link, .visually-hidden') || !button.textContent.trim()) return;
  button.classList.add('ea-has-alfajor');
  const icon = document.createElement('span');
  icon.className = 'ea-button-alfajor';
  icon.setAttribute('aria-hidden', 'true');
  icon.innerHTML = markup;
  button.prepend(icon);
 });
}
decorate(document);
new MutationObserver(records => records.forEach(record => record.addedNodes.forEach(node => {
 if (node.nodeType === 1 && !node.matches('.ea-button-alfajor, .ea-button-alfajor *')) decorate(node);
}))).observe(document.body, {childList:true, subtree:true});
})();